import { AxiosResponse } from 'axios';
import { IncomingHttpHeaders } from 'http';
import { appAxios } from '../libs/axios/appAxios';

interface AccessTokenResponse {
  access_token?: string;
}

/**
 * アクセストークンを取得する
 * @param headers
 * @returns アクセストークン
 */
export const getAccessToken = async (headers?: IncomingHttpHeaders) => {
  return appAxios({
    url: '/dcfront/authorization/user',
    headers,
  }).then((res: AxiosResponse<AccessTokenResponse>) => {
    return res.data.access_token;
  });
};
